export default __webpack_public_path__ + "static/media/oladiwura.cd1b7e04.jpg";